import React from 'react';
import loadable from '@loadable/component';
import Loading from '%evp_ticket_frontend/js/react/component/Loading';

const AsyncSeatingsPage = loadable(() => import('%paysera_seat_selection_integration/js/seatings/Page'), {
    fallback: <Loading />,
});

const SEATINGS = 'seatings';

const routes = [
    {
        id: SEATINGS,
        path: '/step/:eventSlug/select',
        component: props => <AsyncSeatingsPage {...props} />,
    },
];

export default routes;

export {
    SEATINGS,
};
